import React, { useContext, useEffect, useRef, useState } from 'react';
import ViewerContext from '../../context/ViewerContext';
import './timeLine.css'
import TimeLineBarComponent from './TimeLineBarComponent';
// import LineChart from '../timeChart/LineChart';

const TimeLineComponent = () => {

    useEffect(() => {
        // if (viewer.animation?.container) { viewer.animation.container.style.visibility = "hidden"; }
        // if (viewer.timeline?.container) { viewer.timeline.container.style.visibility = "hidden"; }
    }, []);

    return (
        <div className="timeline-container no-select-item">
            {/* <LineChart/> */}
            <TimeLineBarComponent />

        </div>
    );
};

export default TimeLineComponent;
